import React, { Component } from "react";
import { FormControl } from '@mui/material';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from "react-bootstrap/Spinner";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axios from "axios";
import settings from "../helpers/Settings";
import * as moment from 'moment';
import Cookies from "js-cookie";
import {countries} from 'countries-list';
let { KayanURL } = settings;
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid gray',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
};
class UpdatePatient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: this.props.selectedPatient[0].firstname,
      lastName: this.props.selectedPatient[0].lastname,
      phone: this.props.selectedPatient[0].phone,
      identifier: this.props.selectedPatient[0].identifier,
      identifiertype:this.props.selectedPatient[0].identifiertype,
      gender: this.props.selectedPatient[0].gender,
      birthDate: this.props.selectedPatient[0].birthdate,
      nationality: this.props.selectedPatient[0].nationality,
    };
  }
  componentDidMount = async () => {


  };

  HandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    //  if(name === 'department'){
    //   if(value){
    //     this.setState({deptSelected:true,defaultDoctorValue:false})
    //     this.getAllDoctorsByDepartmentID(value);
    //      this.setState({[name]: value});
    //   }else{
    //     this.setState({deptSelected:false})
    //   }

    // }
    // else if(name ==="payment") {
    //   if(value =="insurance"){
    //     this.setState({paymentInsurance:true})
    //   }
    //   else {
    //     this.setState({paymentInsurance:false,insuranceInfo:[]})
    //   }
    //   this.setState({[name]: value });

    // }
    // else if(name === 'doctor'){
    //   this.getDoctorByID(value);
    //   this.setState({[name]: value });

    // }
    // else{
    this.setState({ [name]: value });
    // }
  };
  handleUpdate = async (e) => {
    e.preventDefault();
    this.setState({ requestSent: true, response: false });
    let patientInfo = {
      id: this.props.selectedPatient[0].patientId,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      phone: this.state.phone,
      identifier: this.state.identifier,
      identifiertype:this.state.identifiertype,
      gender: this.state.gender,
      birthDate: this.state.birthDate,
      nationality: this.state.nationality,
    }
    let updatePatient = await axios.put(
      KayanURL + "api/KSA/RCM/patient/updatePatientById",
      {
        patientInfo: patientInfo,
        apiToken: Cookies.get("RCM_KSA_Employee_Token")
      }
    );
    if (updatePatient) {
      this.setState({ requestSent: false, response: true, iqamaFoundMessage: "" });
      let { data } = updatePatient;
      if (data) {
        if (data.success) {
          this.setState({ success: true });
          this.props.backToPatientScreen();
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }

  };
  HandleDateChange = (e) => {
    let date = moment(e.value.$d).format('YYYY-MM-DD')
    this.setState({ [e.name]: date })
  }
  render() {
    let { requestSent, response, error, allDepartments, allDoctors } = this.state;
    const allCountries = Object.entries(countries).map(([code, country]) => ({
      code,
      name: country.name,
    }));

    return (
      <>
        <div style={{ width: "90%", margin: "auto", padding: "20px" }}>
          <FormControl style={{ width: "100%" }}>
            <Container>
              <Row>
                <Col>
                  <Form.Group className="mb-3" >
                    <Form.Label>Patient Identifier</Form.Label>
                    <Form.Control type="text"
                      name="identifier"
                      onChange={this.HandleInputTextChange}
                      required
                      readOnly
                      defaultValue={this.props.selectedPatient[0].identifier}
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-3" >
                    <Form.Label>First Name</Form.Label>
                    <Form.Control type="text"
                      name="firstName"
                      required
                      onChange={this.HandleInputTextChange}
                      placeholder="Enter First Name"
                      defaultValue={this.props.selectedPatient[0].firstname}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Birthdate</Form.Label>
                    <Form.Control
                      name="birthDate"
                      onChange={this.HandleInputTextChange}
                      required
                      type="text"
                      placeholder={this.props.selectedPatient[0].birthdate}
                      onFocus={(e) => e.target.type = 'date'}
                    />
                  </Form.Group>


                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Identifier Type *</Form.Label>
                    <Form.Select
                      onChange={this.HandleInputTextChange}
                      required
                      name="identifiertype"
                      defaultValue={this.props.selectedPatient[0].identifiertype}

                    >
                      <option value="0">select...</option>
                      <option value="iqama">Iqama</option>
                      <option value="passport">Passport</option>
                      <option value="nationalID">National ID</option>
                      <option value="borderNumber">Border Number</option>
                      <option value="displacedNumber">Displaced Number</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-3" >
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control type="text"
                      name="lastName"
                      onChange={this.HandleInputTextChange}
                      required
                      placeholder="Enter Last Name"
                      defaultValue={this.props.selectedPatient[0].lastname}

                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control type="text"
                      name="phone"
                      required
                      onChange={this.HandleInputTextChange}
                      placeholder="Enter Phone"
                      defaultValue={this.props.selectedPatient[0].phone}

                    />
                  </Form.Group>
                  
                </Col>
                <Col>
                {/* <Form.Group className="mb-3" >
                    <Form.Label>Nationality</Form.Label>
                    <Form.Control type="text"
                      name="nationality"
                      onChange={this.HandleInputTextChange}
                      required
                      placeholder="Nationality"
                      defaultValue={this.props.selectedPatient[0].nationality}
                    />
                  </Form.Group> */}
                   <Form.Group className="mb-3">
                        <Form.Label>Nationality *</Form.Label>
                        <Form.Select
                          onChange={this.HandleInputTextChange}
                          required
                          defaultValue={this.props.selectedPatient[0].nationality}
                          name="nationality"
                        >
                          <option value="" >Select a nationality</option>
                          {allCountries.map((nation) => (
                            <option key={nation.code} value={nation.code}>
                              {nation.name} ({nation.code})
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Gender</Form.Label>
                    <Form.Select
                      onChange={this.HandleInputTextChange}
                      required
                      name="gender"
                      defaultValue={this.props.selectedPatient[0].gender}
                    >
                      <option value="0">select...</option>
                      <option value="female">Female</option>
                      <option value="male">Male</option>
                    </Form.Select>
                  </Form.Group>




                  <Button variant="primary" type="submit"
                    onClick={(e) => this.handleUpdate(e)}
                    style={{
                      width: "100%"
                      , marginTop: "30px"
                      , backgroundColor: "rgb(97 110 120"
                      , border: "1px solid rgb(97 110 120"
                    }}>
                    Update
                  </Button>
                </Col>
              </Row>
              <div style={{ width: "50%", marginright: "auto", textAlign: "left" }}>
                <Button variant="primary" type="submit"
                  onClick={() => this.props.backToPatientScreen()
                  }
                  style={{
                    width: "10%"
                    , marginTop: "32px",
                    padding: "3px 6px"
                    , backgroundColor: "rgb(97 110 120"
                    , border: "1px solid rgb(97 110 120"
                  }}>
                  <ArrowBackIcon />
                </Button>
              </div>
            </Container>
          </FormControl>
          <div>
            {requestSent && !response ? (
              <div style={{ textAlign: "center" }}>
                <Spinner animation="border" variant="success" />
              </div>
            ) : response && error ? (
              <h5 style={{ color: "red" }}>{error}</h5>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

export default UpdatePatient;
